"use client";

import { useCallback, useMemo } from "react";

import cn from "classnames";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { TextColor } from "@/components/Text";
import { languages } from "@/constants";
import { switchLang } from "@/services/i18n";

import { LangItem } from "./LangItem";

import styles from "./LangSwitcher.module.scss";

interface LangSwitcherProps {
  containerClassName?: string;
  activeColor: TextColor;
  inactiveColor: TextColor;
}

export const LangSwitcher = observer(function LangSwitcher(
  props: LangSwitcherProps
) {
  const { containerClassName, activeColor, inactiveColor } = props;

  const { i18n } = useTranslation();

  const containerClasses = cn(styles.container, containerClassName);

  const currentLanguage = i18n.language;

  const handleLanguageSelect = useCallback(
    (code: string) => () => {
      switchLang(code);
    },
    []
  );

  const Languages = useMemo(() => {
    return languages.map(({ code, title }) => (
      <LangItem
        key={code}
        title={title}
        active={code === currentLanguage}
        onClick={handleLanguageSelect(code)}
        activeColor={activeColor}
        inactiveColor={inactiveColor}
      />
    ));
  }, [activeColor, inactiveColor, currentLanguage, handleLanguageSelect]);

  return (
    <div className={containerClasses}>
      {languages.length > 0 && <div className={styles.langs}>{Languages}</div>}
    </div>
  );
});
